<template>
  <v-app>
    <Appbar />
    <v-main>
      <Information />
      <v-card
        :tile="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs"
        class="mb-10 mt-4 mx-auto fill-width"
        flat
        max-width="640"
      >
        <v-card-title class="text-center pa-8">
          <h4 class="fill-width">
            設定
          </h4>
        </v-card-title>
        <div class="px-6 py-8">
          <div class="mx-auto">
            <v-list
              action
              dense
              subheader
              two-line
            >
              <v-subheader>アカウント・課金</v-subheader>
              <v-list-item :to="isPremium ? '/payments' : '/input-card'">
                <v-list-item-content>
                  <v-list-item-title>プレミアムプランの{{ isPremium ? '契約の変更' : '購入' }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item three-line @click="selectAddProviderDialog= true">
                <v-list-item-content >
                  <v-list-item-title>別のアカウントとのリンク</v-list-item-title>
                  <v-list-item-subtitle aria-multiline="true">
                    現在ログイン中のアカウントとは別のGoogle・Twitter・AppleIDでログインできるように追加することができます。※現在利用中のプロバイダはご利用いただけません
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider />
              <v-subheader>執筆設定</v-subheader>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>フォントサイズ</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-select
                    :items="fontSizeType"
                    :value="user.writerFontSizeTypeKeyValue"
                    item-text="label"
                    item-value="value"
                    return-object
                    style="width: 100px"
                    @input="updateParams('writerFontSizeTypeKeyValue',$event)"
                  />
                </v-list-item-action>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>テキストの行間</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-select
                    :items="fontLineSpaceSizeType"
                    :value="user.writerLineSpaceTypeKeyValue"
                    item-text="label"
                    item-value="value"
                    return-object
                    style="width: 100px"
                    @input="updateParams('writerLineSpaceTypeKeyValue',$event)"
                  />
                </v-list-item-action>
              </v-list-item>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title>改行時に自動字下げを行う</v-list-item-title>
                  <v-list-item-subtitle aria-multiline="true">
                    改行時にスペースを自動で入力、「を入力した場合は自動で取り下げます。
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch
                    :input-value="user.autoSpace"
                    @change="updateParams('autoSpace',$event);"
                  />
                </v-list-item-action>
              </v-list-item>

              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title>感嘆符・疑問符の後ろにスペースを入れる</v-list-item-title>
                  <v-list-item-subtitle aria-multiline="true">
                    改行したタイミングで、入力したテキストに？や！の後ろにスペースが無いテキストがある場合、スペースを自動補完します。
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch
                    :input-value="user.questionAfterSpace"
                    @change="updateParams('questionAfterSpace',$event);"
                  />
                </v-list-item-action>
              </v-list-item>

              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title>三点リーダー・―の強制連続</v-list-item-title>
                  <v-list-item-subtitle aria-multiline="true">
                    改行したタイミングで、入力したテキストに…や－が２回連続していないテキストがある場合、自動補完します。
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch
                    :input-value="user.threePointReaderRule"
                    @change="updateParams('threePointReaderRule',$event);"
                  />
                </v-list-item-action>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>クイックメニューを一行で表示</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch
                    :input-value="user.oneline"
                    @change="updateParams('oneline',$event);"
                  />
                </v-list-item-action>
              </v-list-item>

              <v-list-item @click="showQuickMenuSettingDialog">
                <v-list-item-content>
                  <v-list-item-title>クイックメニュー編集</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider />
              <v-subheader>デザイン設定</v-subheader>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title>ダークモード</v-list-item-title>
                  <v-list-item-subtitle aria-multiline="true">
                    テーマカラーの設定によってはボタンが見えづらく感じるケースがあります。その場合はテーマカラーを他のものに変更をお試しください。
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch
                    :input-value="user.dark"
                    @change="updateParams('dark',$event);"
                  />
                </v-list-item-action>
              </v-list-item>

              <v-list-item
                three-line
                @click="showThemeSetting"
              >
                <v-list-item-content>
                  <v-list-item-title>テーマカラー</v-list-item-title>
                  <v-list-item-subtitle aria-multiline="true">
                    ヘッダーとボタンの色をカスタマイズします
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider />
              <v-subheader>その他</v-subheader>
              <v-list-item
                dense
                to="/terms"
              >
                <v-list-item-title>利用規約</v-list-item-title>
              </v-list-item>
              <v-list-item
                dense
                to="/policy"
              >
                <v-list-item-title>プライバシーポリシー</v-list-item-title>
              </v-list-item>
              <v-list-item
                dense
                to="/tokushou"
              >
                <v-list-item-title>特定商取引法</v-list-item-title>
              </v-list-item>

              <v-list-item>
                <v-spacer />
                <v-btn
                  color="red"
                  outlined
                  @click="leaveDialog=true"
                >
                  退会手続き
                </v-btn>
              </v-list-item>
            </v-list>
          </div>
        </div>
      </v-card>
    </v-main>
    <Footer
      :accent-color="accentColor"
      :sub-primary-color="subPrimaryColor"
    />

    <v-dialog
      v-model="leaveDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">
          退会確認
        </v-card-title>
        <v-card-text>
          退会すると、サーバー上に保管されたアカウントに紐づくデータは全て削除されます。復元することは出来ません。<br><br>
          また、AppStoreやGooglePlayからプレミアムプランにご加入の場合、別途継続課金の解約を行わない限り課金が継続されますので、ご注意ください。
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="leaveDialog = false"
          >
            キャンセル
          </v-btn>
          <v-btn
            color="red"
            outlined
            @click="doLeave()"
          >
            確認の上、退会する
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="selectAddProviderDialog"
      max-width="400"
      >
     <v-card>
       <v-card-title>連携追加アカウント選択</v-card-title>
       <v-card-text>
         <v-list dense >
           <v-list-item dense  v-if="userProvider.indexOf('google.com')==-1" @click="linkProvider('google')">
             <v-list-item-content>
               Googleアカウントを追加
             </v-list-item-content>
           </v-list-item>
           <v-list-item dense v-if="userProvider.indexOf('apple.com')==-1"  @click="linkProvider('apple')">
             <v-list-item-content>
               AppleIDを追加
             </v-list-item-content>
           </v-list-item>
           <v-list-item dense v-if="userProvider.indexOf('twitter.com')==-1"  @click="linkProvider('twitter')">
             <v-list-item-content >
               Twitterアカウントを追加
             </v-list-item-content>
           </v-list-item>
         </v-list>
       </v-card-text>
     </v-card>
    </v-dialog>
    <quick-menu-setting-dialog :dialogs="quickmenuDialogs" />
    <theme-dialog :dialogs="themeDialogs" />
  </v-app>
</template>

<script>
import {mapState} from "vuex";
import config from "@/const";
import QuickMenuSettingDialog from "../component/QuickMenuSettingDialog.vue";
import ThemeSelectDialog from "@/component/ThemeSelectDialog";
import Footer from '../component/Footer.vue';
import Appbar from '../component/Appbar.vue';
import Information from '../component/Information.vue';
import router from "@/router";
import firebase from "firebase";
export default {
  name: "Setting",
  data() {
    return {
      leaveDialog: false,
      fontSizeType: config.WRITER_FONT_SIZE_VALUES_MASTER,
      fontLineSpaceSizeType: config.WRITER_FONT_LINE_SPACE_VALUES_MASTER,
      quickmenuDialogs: {
        quickmenuDialog: false,
      },
      themeDialogs: {
        themeDialog: false
      },
      accentColor: null,
      subPrimaryColor: null,
      selectAddProviderDialog:null,
      userProvider: firebase.auth().currentUser.providerData.map(value => value.providerId),
    }
  },
  computed: {
    ...mapState({
      user: state => state.userModule.user,
      isPremium: state => state.userModule.isPremium,
      EditorMenu: state => state.EditorMenuModule.EditorMenu
    })
  },
  watch: {},
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
    const primary = this.$vuetify.theme.themes.light.primary
    const red = parseInt(primary.substring(1, 3), 16);
    const green = parseInt(primary.substring(3, 5), 16);
    const blue = parseInt(primary.substring(5, 7), 16);

    this.subPrimaryColor = "#" + (red + 37).toString(16) + (green + 24).toString(16) + (blue + 9).toString(16)

  },
  methods: {
    linkProvider(providerName){
      const auth=firebase.auth
      let provider = null
      if(providerName === "twitter")
      provider= new firebase.auth.TwitterAuthProvider()
      else if(providerName ==="google")
        provider= new firebase.auth.GoogleAuthProvider()
        else
        provider= new firebase.auth.OAuthProvider('apple.com')
      firebase.auth().currentUser.linkWithPopup(provider).then((result)=>{
        if(result.credential){
          const user = result.user;
          alert("リンク手続きが完了しました。追加したアカウントからも今後はログインが可能となります。")

        }else{
          alert("処理中にエラーが発生しました。既に別のアカウントに紐づいているアカウントをご利用の場合は別のアカウントをご利用ください。")
        }
      })
          .catch(reason => {
            console.log("reason",reason)
            if(reason.code==="auth/credential-already-in-use"){
              alert("処理中にエラーが発生しました。既に別のアカウントに紐づいているアカウントをご利用の場合は別のアカウントをご利用ください。")
            }else{
              alert("処理中にエラーが発生しました。何度も発生する場合はお問い合わせよりご連絡ください。")
            }
          }).finally(() => {
        this.selectAddProviderDialog=false
      })
    },
    doLeave() {
      this.$store.dispatch("userModule/leave").then(value => {
        router.push('/signup')
      }).catch(reason => {
        alert("処理中にエラーが発生しました。何度も発生する場合はお問い合わせよりご連絡ください。")
      })
    },
    updateParams(key, value) {
      this.$store.dispatch("userModule/updateParams", {[key]: value})
      this.saveSettings()
    },
    showQuickMenuSettingDialog() {
      this.quickmenuDialogs.quickmenuDialog = true
    },
    showThemeSetting() {
      this.themeDialogs.themeDialog = true
    },
    saveSettings() {
      this.$store.dispatch("userModule/saveSetting").then(value => {
        this.accentColor = this.$vuetify.theme.themes.light.secondary
        const primary = this.$vuetify.theme.themes.light.primary
        const red = parseInt(primary.substring(1, 3), 16);
        const green = parseInt(primary.substring(3, 5), 16);
        const blue = parseInt(primary.substring(5, 7), 16);

        this.subPrimaryColor = "#" + (red + 37).toString(16) + (green + 24).toString(16) + (blue + 9).toString(16)
      }).catch(reason => {
        alert("保存中にエラーが発生しました。もう一度保存してください")
      });
    }

  },
  components: {
    quickMenuSettingDialog: QuickMenuSettingDialog,
    themeDialog: ThemeSelectDialog,
    Footer,
    Appbar,
    Information
  },
}
</script>

<style scoped>

</style>